import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { createElement } from 'react';

import { InvoiceInboxPage } from '~/modules/invoice/inbox/InvoiceInboxPage';

import { i18n } from '~/utils';
import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';
import { getRouteHead } from '~/utils/routeUtils';

import { routeParams } from '../incoming/-routeParams';

import {
  defaultInvoiceInboxSearch,
  validateInvoiceInboxSearch,
} from './-searchParams';

const title = i18n.t(($) => $.inbox.pageTitle, { ns: 'invoice' });

export const Route = createFileRoute('/(main)/invoices/inbox/')({
  beforeLoad: createProtectedRoute({
    routePath: '/invoices/inbox/',
    ...routeParams,
  }),
  component: () => createElement(InvoiceInboxPage),
  head: () => getRouteHead(title),
  search: {
    middlewares: [stripSearchParams(defaultInvoiceInboxSearch)],
  },
  staticData: {
    AppBar: {
      title,
    },
  },
  validateSearch: validateInvoiceInboxSearch,
});

export const INVOICE_INBOX = buildRouteExport({
  Route,
  ...routeParams,
});
